import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import {
  Card,
  Text,
  SearchResultsAdvanced,
  NotificationList,
  useResponsiveParams,
  Button,
  Paper,
  Grid,
  GridItem,
  QuantaInput,
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faEnvelope,
  faExclamationTriangle,
  faMobileAlt,
  faMotorcycle,
  faSearch,
  faSpinner,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

import {
  // LOB_PRODUCT_LIST,
  // DATE_RANGE,
  // QUOTE_STATUS_LIST,
  // SEARCH_QUOTES,
  INTERMEDIARY_LIST,
  // VIEW_QUOTE_TW,
  GET_TWO_WHEELER_POLICY_VAR_DETAILS,
  // META_QUERIES,
  // VIEW_QUOTE_TW,
  // META_QUERIES
} from '../queries';
import { DATE_RANGE,
  LOB_PRODUCT_LIST ,
  QUOTE_STATUS_LIST,
  SEARCH_QUOTES,
 
} from 'quanta-flows/modules/quote/motor';
import { VIEW_QUOTE_TW,META_QUERIES } from '../../../../view-quote-details/queries';

// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import { initBuyHealthPolicyVar } from '../../../new-policy-issuance/health/_graphql/state';
import { initBuyMotorPolicyVar } from 'quanta-flows/modules/proposal/motor/state';
// import { initBuyMotorPolicyVar } from '../../../new-policy-issuance/two-wheeler/_graphql/state';
// import { updateMotorQuote } from '../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
// import { initBuyIpaPolicyVar } from '../../../new-policy-issuance/personal-accident/_graphql/state';
// import { initBuyWmcPolicyVar } from '../../../new-policy-issuance/workmen-compensation/_graphql/state';
// import { initBuyFirePolicyVar } from '../../../new-policy-issuance/fire/_graphql/state';
import QuickSearchTwoWheeler from './quick-search-two-wheeler';

const offset = 0;
const PAGE_SIZE = 4;

export default function SmartSearchPanelTwoWheeler({
  alerts,
  setAlerts,
  voice,
  setCopyQuoteDisplay,
  setMoveToPlans,
  category,
  productName,
}) {
  const {
    product_code: productCodeFromURL,
    lob_code: lobCodeFromURL,
  } = useParams();
  const [searchData, setSearchData] = useState([]);
  const [searchQuoteMeta, setSearchQuoteMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isIdle, setIdle] = useState(true);
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [copying, setCopying] = useState(false);
  const [copyFromQuoteNumber, setCopyFromQuoteNumber] = useState('');

  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  const inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const fetchQuery = useFetchQuery();

  useEffect(() => {
    // initBuyHealthPolicyVar();
    initBuyMotorPolicyVar();
    // initBuyIpaPolicyVar();
    // initBuyWmcPolicyVar();
    // initBuyFirePolicyVar();
  }, []);

  const { loading: loadingIntermediary, data: intermediaryData } =
    useQuery(INTERMEDIARY_LIST);

  const { loading: loadingLobDropdown, data: lobDropdownDetais } =
    useQuery(LOB_PRODUCT_LIST, {
      fetchPolicy: 'cache-first',
    });

  const { loading: loadingDateRange, data: dateRangeData } = useQuery(
    DATE_RANGE,
    {
      variables: {
        type: 'Quote',
      },
      fetchPolicy: 'cache-first',
    },
  );

  const {
    loading: loadingQuoteStatusDropdown,
    data: quoteStatusDropdown,
  } = useQuery(QUOTE_STATUS_LIST, {
    fetchPolicy: 'cache-first',
  });

  if (
    loadingLobDropdown ||
    loadingQuoteStatusDropdown ||
    loadingIntermediary ||
    loadingDateRange
  ) {
    return (
      <Card className="min-h-screen">
        <Loading />
      </Card>
    );
  }

  const { lobProductList } = lobDropdownDetais;
  const { dateRange } = dateRangeData;
  const { quoteStatusList } = quoteStatusDropdown;
  const { myIntermediaries } = intermediaryData;

  const initialValues = {
    intermediaryCode: myIntermediaries.find((imd) => imd.isSelected)
      ?.intermediaryCode,
    startDate: moment()
      .subtract(dateRange.min, 'months')
      .format('DD/MM/YYYY')
      .toString(),
    endDate: moment().format('DD/MM/YYYY').toString(),
    productCode: category ? category : productCodeFromURL,
    productVariant: productCodeFromURL ? productCodeFromURL : '',
    customerName: '',
    customerMobile: '',
    quoteStatus: quoteStatusList[0].code,
    quoteNumber: '',
    lob: '',
    searchType: 'I have a Quotation Number',
    registrationNumber: '',
    registrationNumberParts: {
      part1: '',
      part2: '',
      part3: '',
      part4: '',
    },
    fuzzySearch: '',
  };

  const formValidate = (values) => {
    const errors = {};
    if (!values.intermediaryCode) {
      errors.intermediaryCode = '* Required';
    }
    if (
      !values.quoteNumber &&
      !values.customerName &&
      !values.customerMobile &&
      !advancedSearch
    ) {
      errors.fuzzySearch = '* Required';
    }
    if (advancedSearch) {
      if (!values.startDate || values.startDate === '') {
        errors.startDate = '* Required';
      } else if (!values.endDate || values.endDate === '') {
        errors.endDate = '* Required';
      }
      if (!values.productCode || values.productCode === '') {
        errors.productCode = '* Required';
      }
    }

    if (values.startDate !== '' && values.endDate !== '') {
      if (
        moment(values.endDate, 'DD/MM/YYYY').diff(
          moment(values.startDate, 'DD/MM/YYYY'),
          'months',
        ) > dateRange.max
      ) {
        errors.endDate = `* Date Range cannot be greater than ${dateRange.max} months`;
      }
      if (
        moment(values.endDate, 'DD/MM/YYYY').isBefore(
          moment(values.startDate, 'DD/MM/YYYY'),
        )
      ) {
        errors.endDate = '* To Date cannot be before From Date';
      }
    }
    if (values?.customerName) {
      if (values.customerName.match(/^[0-9]+$/)) {
        errors.customerName = '* Customer Name cannot be all numeric';
      } else if (values.customerName.match(/^[_@!$%*^()=./#&+-]*$/)) {
        errors.customerName =
          '* Customer Name cannot be all special characters';
      } else if (values.customerName.match(/\d/)) {
        errors.customerName =
          '* Customer Name cannot be alphanumeric';
      }
    }
    return errors;
  };

  const searchInput = {
    flow: 'cols',
    repeat: inputColSpans,
    gapX: 8,
    gapY: 1,
    // title: 'Search Quotes',
    data: [
      ...(!advancedSearch
        ? [
            {
              type: 'render',
              size: 'full',
              colSpan: 4,
              component: (values, setFieldValue, resetForm) => (
                <QuickSearchTwoWheeler
                  {...{
                    myIntermediaries,
                    setAdvancedSearch,
                    loading,
                    values,
                    setFieldValue,
                    voice,
                    disabled: copying,
                  }}
                />
              ),
            },
            // {
            //   type: 'render',
            //   colSpan: inputColSpans,
            //   component: (values, setFieldValue, resetForm) => {
            //     return (
            //       <div className="flex justify-end space-x-2 mb-4">
            //         <Button
            //           flat={true}
            //           type="button"
            //           className="w-40"
            //           onClick={(_) => {
            //             const otherFormValues = {
            //               intermediaryCode: values?.intermediaryCode,
            //               lob: values?.lob,
            //               productCode: values?.productCode,
            //               customerName: values?.customerName,
            //               startDate: values?.startDate,
            //               endDate: values?.endDate,
            //               quoteStatus: values?.quoteStatus,
            //               searchType: values?.searchType,
            //             };
            //             resetForm(initialValues);
            //             Object.keys(otherFormValues).forEach((k) => {
            //               setFieldValue(k, otherFormValues[k]);
            //             });
            //             setProductCode(null);
            //             setLocalValues({
            //               intermediaryCode: values?.intermediaryCode,
            //               lob: values?.lob,
            //               productCode: values?.productCode,
            //               customerName: values?.customerName,
            //               startDate: values?.startDate,
            //               endDate: values?.endDate,
            //               quoteStatus: values?.quoteStatus,
            //               searchType: values?.searchType,
            //             });
            //           }}
            //         >
            //           Reset
            //         </Button>
            //         <Button
            //           flat={false}
            //           type="submit"
            //           className="w-40"
            //           disabled={loading}
            //           iconPre={
            //             loading ? (
            //               <FontAwesomeIcon
            //                 icon={faSpinner}
            //                 spin={true}
            //               />
            //             ) : (
            //               <FontAwesomeIcon
            //                 icon={faSearch}
            //                 className="mx-2"
            //               />
            //             )
            //           }
            //         >
            //           Search
            //         </Button>
            //       </div>
            //     );
            //   },
            // },
          ]
        : [
            {
              type: 'select',
              size: 'full',
              label: (
                <div>
                  Choose Intermediary <Text severity="error">*</Text>
                </div>
              ),
              name: 'intermediaryCode',
              disableSelect: true,
              disabled: copying,
              data: myIntermediaries
                ? [
                    ...myIntermediaries.map((intermediaryCode) => {
                      return {
                        label: intermediaryCode.intermediaryName
                          ? intermediaryCode.intermediaryName
                          : '',
                        value: intermediaryCode.intermediaryCode
                          ? intermediaryCode.intermediaryCode
                          : '',
                      };
                    }),
                  ]
                : [],
            },
            {
              type: 'date',
              size: 'full',
              label: (
                <div>
                  From Date <Text severity="error">*</Text>
                </div>
              ),
              name: 'startDate',
              scrollStopWhenCalendarOpen: false,
              disabled: copying,
            },
            {
              type: 'date',
              size: 'full',
              label: (
                <div>
                  To Date <Text severity="error">*</Text>
                </div>
              ),
              name: 'endDate',
              scrollStopWhenCalendarOpen: false,
              disabled: copying,
            },
            {
              type: 'text',
              size: 'full',
              label: (
                <div>
                  Customer Name <Text severity="error"></Text>
                </div>
              ),
              name: 'customerName',
              disabled: copying,
            },
            {
              type: 'select',
              size: 'full',
              mega: true,
              label: (
                <div>
                  Product <Text severity="error">*</Text>
                </div>
              ),
              name: 'productCode',
              disabled: true,
              data: lobProductList?.map((lob) => {
                return {
                  category: lob.lob_name,
                  values: lob.category.map((cat) => {
                    return {
                      label: cat,
                      value: cat,
                    };
                  }),
                };
              }),
            },
            {
              type: 'select',
              size: 'full',
              label: (
                <div>
                  Quote Status <Text severity="error"></Text>
                </div>
              ),
              name: 'quoteStatus',
              disabled: copying,
              disableSelect: true,
              data: quoteStatusList
                ? [
                    ...quoteStatusList.map((quoteStatus) => {
                      return {
                        label: quoteStatus.value
                          ? quoteStatus.value
                          : '',
                        value: quoteStatus.code
                          ? quoteStatus.code
                          : '',
                      };
                    }),
                  ]
                : [],
            },
            {
              type: 'select',
              size: 'full',
              disabled: true,
              label: (
                <div>
                  Product Variant <Text severity="error">*</Text>
                </div>
              ),
              name: 'productVariant',
              data: lobProductList
                .find((ele) => ele.category.includes(category))
                .products.filter(
                  (ele) => ele.product_category === category,
                )
                .map((ele) => {
                  return {
                    label: productName,
                    value: productCodeFromURL,
                  };
                }),
            },
            lobProductList
              ?.find((lob) =>
                lob?.products?.find(
                  (product) =>
                    product?.product_code
                      ?.toString()
                      ?.toLowerCase() ===
                    productCodeFromURL?.toString()?.toLowerCase(),
                ),
              )
              ?.lob_name?.toString()
              ?.toLowerCase() === 'motor'
              ? {
                  type: 'input-wrapper',
                  size: 'full',
                  fields: [
                    'registrationNumberParts.part1',
                    'registrationNumberParts.part2',
                    'registrationNumberParts.part3',
                    'registrationNumberParts.part4',
                  ],
                  children: (
                    <>
                      <QuantaInput
                        name="registrationNumberParts.part1"
                        maxLength="2"
                        size="full"
                        type="text"
                        placeholder="MH"
                        noerror
                        className="uppercase"
                        onKeyUp={(e) => {
                          if (e.target.value.length === 2) {
                            document
                              .getElementsByName(
                                'registrationNumberParts.part2',
                              )
                              .forEach((e) => e.focus());
                          }
                        }}
                        onDataChange={(val, setFieldValue) => {
                          setFieldValue(
                            `registrationNumberParts.part1`,
                            val?.toString()?.toUpperCase(),
                          );
                        }}
                      />
                      <Text
                        className={`flex items-center font-bold h-12`}
                      >
                        -
                      </Text>
                      <QuantaInput
                        name="registrationNumberParts.part2"
                        maxLength="2"
                        size="full"
                        type="text"
                        placeholder="01"
                        noerror
                        onKeyUp={(e) => {
                          if (e.target.value.length === 2) {
                            document
                              .getElementsByName(
                                'registrationNumberParts.part3',
                              )
                              .forEach((e) => e.focus());
                          }
                        }}
                      />
                      <Text
                        className={`flex items-center font-bold h-12`}
                      >
                        -
                      </Text>
                      <QuantaInput
                        name="registrationNumberParts.part3"
                        maxLength="2"
                        size="full"
                        type="text"
                        placeholder="CR"
                        noerror
                        className="uppercase"
                        onKeyUp={(e) => {
                          if (e.target.value.length === 2) {
                            document
                              .getElementsByName(
                                'registrationNumberParts.part4',
                              )
                              .forEach((e) => e.focus());
                          }
                        }}
                        onDataChange={(val, setFieldValue) => {
                          setFieldValue(
                            `registrationNumberParts.part3`,
                            val?.toString()?.toUpperCase(),
                          );
                        }}
                      />
                      <Text
                        className={`flex items-center font-bold h-12`}
                      >
                        -
                      </Text>
                      <QuantaInput
                        name="registrationNumberParts.part4"
                        maxLength="4"
                        size="full"
                        type="text"
                        placeholder="2845"
                        noerror
                      />
                    </>
                  ),
                  label: (
                    <Text type={'label'}>
                      Vehicle Registration Number
                    </Text>
                  ),
                  name: 'registrationNumber',
                }
              : null,
            {
              type: 'render',
              colSpan: inputColSpans,
              component: (values, setFieldValue, resetForm) => {
                return (
                  <div
                    className={`flex ${
                      screenType?.toString()?.toLowerCase() ===
                      'mobile'
                        ? 'flex-col space-y-2 justify-between items-center'
                        : 'space-x-2 justify-end'
                    } mb-4`}
                  >
                    <Text
                      className={
                        screenType?.toString()?.toLowerCase() ===
                        'mobile'
                          ? 'w-full'
                          : ''
                      }
                    >
                      <Button
                        flat={true}
                        type="button"
                        className={`w-${
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'full'
                            : '40'
                        } border-0`}
                        onClick={(_) => setAdvancedSearch(false)}
                        disabled={copying}
                      >
                        Quick Search
                      </Button>
                    </Text>
                    <Text
                      className={
                        screenType?.toString()?.toLowerCase() ===
                        'mobile'
                          ? 'w-full'
                          : ''
                      }
                    >
                      <Button
                        flat={true}
                        type="button"
                        className={`w-${
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'full'
                            : '40'
                        }`}
                        disabled={copying}
                        onClick={(_) => {
                          const otherFormValues = {
                            intermediaryCode:
                              values?.intermediaryCode,
                            quoteNumber: values?.quoteNumber,
                            searchType: values?.searchType,
                          };
                          resetForm(initialValues);
                          Object.keys(otherFormValues).forEach(
                            (k) => {
                              setFieldValue(k, otherFormValues[k]);
                            },
                          );
                        }}
                      >
                        Reset
                      </Button>
                    </Text>
                    <Text
                      className={
                        screenType?.toString()?.toLowerCase() ===
                        'mobile'
                          ? 'w-full'
                          : ''
                      }
                    >
                      <Button
                        flat={false}
                        type="submit"
                        className={`w-${
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'full'
                            : '40'
                        }`}
                        disabled={loading || copying}
                        iconPre={
                          loading ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faSearch}
                              className="mx-2"
                            />
                          )
                        }
                      >
                        Search
                      </Button>
                    </Text>
                  </div>
                );
              },
            },
          ]?.filter((d) => d)),
    ],
    initialValues,
    validate: formValidate,
    onSearch: async (values) => {
      try {
        setSearchData([]);
        setAlerts([]);
        let { lob, ...requestBody } = values;
        requestBody.startDate = moment(
          requestBody.startDate,
          'DD-MM-YYYY',
        ).format('YYYY-MM-DD');
        requestBody.endDate = moment(
          requestBody.endDate,
          'DD-MM-YYYY',
        ).format('YYYY-MM-DD');

        let queryOutput = fetchQuery({
          query: SEARCH_QUOTES,
          variables: advancedSearch
            ? {
                filter: {
                  intermediaryCode: values?.intermediaryCode,
                  productCode: category
                    ? values?.productVariant
                    : values?.productCode,
                  customerName: values?.customerName,
                  startDate: requestBody?.startDate,
                  endDate: requestBody?.endDate,
                  quoteStatus: values?.quoteStatus,
                  vehicleRegNum: `${values?.registrationNumberParts?.part1}${values?.registrationNumberParts?.part2}${values?.registrationNumberParts?.part3}${values?.registrationNumberParts?.part4}`,
                  isFuzzySearch: false,
                },
              }
            : values?.customerName
            ? {
                filter: {
                  intermediaryCode: values?.intermediaryCode,
                  customerName: values?.customerName,
                  productCode: category
                    ? values?.productVariant
                    : values?.productCode,
                  isFuzzySearch: true,
                },
              }
            : values?.customerMobile
            ? {
                filter: {
                  intermediaryCode: values?.intermediaryCode,
                  mobileNumber: values?.customerMobile,
                  productCode: category
                    ? values?.productVariant
                    : values?.productCode,
                  isFuzzySearch: true,
                },
              }
            : {
                filter: {
                  intermediaryCode: values?.intermediaryCode,
                  quoteNumber: values?.quoteNumber,
                  productCode: category
                    ? values?.productVariant
                    : values?.productCode,
                  isFuzzySearch: true,
                },
              },
          fetchPolicy: 'network-only',
        });
        setLoading(true);
        let { data } = await queryOutput;
        setLoading(false);
        if (
          data.searchQuotes.length === 0 &&
          data._quote_meta.metaMessage
        ) {
          setAlerts([
            {
              header: data._quote_meta.metaMessage.header,
              id: 1,
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{data._quote_meta.metaMessage.message}</span>
                </div>
              ),
              type: data._quote_meta.metaMessage.type,
              timeout: null,
              disableClose: false,
            },
          ]);
          //   setCardSummaryDetail(undefined);
        }
        // if (data.searchQuotes.length === 1 && systemConfig?.searchRedirect === true) {
        //   history.push(
        //     `/quote/saved/${data?.searchQuotes[0]?.lob?.lobCode}/${data?.searchQuotes[0]?.lob?.lobName}/${data?.searchQuotes[0]?.product?.productCode}/${data?.searchQuotes[0]?.product?.productName}/${data.searchQuotes[0].quoteNumber}`,
        //   );
        // }
        //setSearchData(data?.searchQuotes?.filter((quote)=>quote?.product?.productCode?.toString()?.toLowerCase() === productCodeFromURL?.toString()?.toLowerCase()));
        setSearchData(data.searchQuotes);
        setSearchQuoteMeta(data._quote_meta);
        setIdle(false);
      } catch (error) {
        setAlerts([
          {
            header: 'Quotes fetch failed',
            id: 1,
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoading(false);
      }
    },
  };

  let searchResults = {
    data: searchData,
    onIdle: () => {
      if (loading) return <Loading />;
      else if (isIdle) return <></>;
      return undefined;
    },
    columns: [
      {
        Header: 'Customer Name',
        Cell: ({ row }) => {
          return (
            <div className="flex flex-col justify-center break-normal max-w-xs">
              <span>
                {row.original?.customer?.org_detail?.org_name
                  ? row.original?.customer?.org_detail?.org_name
                  : row.original?.customer?.indv_detail?.full_name
                  ? row.original?.customer?.indv_detail?.full_name
                  : [
                      row.original?.customer?.indv_detail?.first_name?.trim(),
                      row.original?.customer?.indv_detail?.middle_name?.trim(),
                      row.original?.customer?.indv_detail?.surname?.trim(),
                    ].join(' ')}
              </span>
            </div>
          );
        },
      },
      {
        Header: 'Contact',
        Cell: ({ row }) => {
          return (
            <div className="flex flex-col justify-center">
              <span>
                {row.original.customer &&
                row.original.customer.contact &&
                row.original.customer.contact.email
                  ? row.original.customer.contact.email
                  : null}
              </span>
              <span>
                {row.original.customer &&
                row.original.customer.contact &&
                row.original.customer.contact.mobile
                  ? row.original.customer.contact.mobile
                  : null}
              </span>
            </div>
          );
        },
      },
      {
        Header: 'Quote Reference Number',
        accessor: 'quoteNumber',
      },
      {
        Header: 'Quote Status / Saved On',
        Cell: ({ row }) => {
          return (
            <div className="flex flex-col justify-center">
              <span>{row.original?.quoteStatus}</span>
              <span>{row.original?.quoteCreationDate}</span>
            </div>
          );
        },
      },
      {
        Header: ' ',
        Cell: ({ row }) => {
          return (
            <Text className="flex justify-end w-full">
              <Button
                type={'button'}
                flat={false}
                onClick={async (e) => {
                  e.stopPropagation();
                  try {
                    const fetchQuoteDetails = fetchQuery({
                      query: VIEW_QUOTE_TW,
                      variables: {
                        input: {
                          quoteNumber: row?.original?.quoteNumber,
                        },
                      },
                    });
                    const getMotorQuoteVar = fetchQuery({
                      query: GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                    });
                    setAlerts([]);
                    setCopyFromQuoteNumber(
                      row?.original?.quoteNumber,
                    );
                    setCopying(true);
                    const { data: quoteDetailsData } =
                      await fetchQuoteDetails;
                    const { data: motorReactiveVarData } =
                      await getMotorQuoteVar;
                    const metaQuery = fetchQuery({
                      query: META_QUERIES,
                      variables: {
                        productCode:
                          quoteDetailsData?.viewQuoteTW?.product
                            ?.productCode,
                        productType:
                          quoteDetailsData?.viewQuoteTW?.productType,
                      },
                    });
                    const { data: metaQueryData } = await metaQuery;
                    const {
                      lobProductList,
                      getTwoWheelerBusinessType,
                      PRD_TotalClaimCountList,
                      PRD_PreviousPolicyTermList,
                    } = metaQueryData;
                    const { motorQuote } = motorReactiveVarData;
                    setCopying(false);
                    updateMotorQuote({
                      currentTab: 'covers',
                      captureMode: 'create',
                      productType:
                        quoteDetailsData?.viewQuoteTW?.productType,
                      productTypeValue: lobProductList
                        ?.find(
                          (lpl) =>
                            lpl?.lob_code
                              ?.toString()
                              ?.toLowerCase() ===
                            lobCodeFromURL?.toString()?.toLowerCase(),
                        )
                        ?.products?.find(
                          (prd) =>
                            prd?.product_code
                              ?.toString()
                              ?.toLowerCase() ===
                            productCodeFromURL
                              ?.toString()
                              ?.toLowerCase(),
                        )
                        ?.product_types?.find(
                          (p) =>
                            p?.code?.toLowerCase() ===
                            quoteDetailsData?.viewQuoteTW?.productType?.toLowerCase(),
                        )?.value,
                      businessType:
                        quoteDetailsData?.viewQuoteTW?.businessType,
                      businessTypeValue:
                        getTwoWheelerBusinessType?.value,
                      regNo:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.registrationNumber,
                      quotationType:
                        quoteDetailsData?.viewQuoteTW?.quotationType,
                      isRegNoVerified: true,
                      isPrevClaimsAvailable:
                        getTwoWheelerBusinessType?.value?.toLowerCase() ===
                        'roll over'
                          ? true
                          : false,
                      isPrevInsuranceAvailable:
                        getTwoWheelerBusinessType?.value?.toLowerCase() ===
                        'roll over'
                          ? true
                          : false,
                      mode: '',
                      vehicleRegNo: {
                        part1: `${
                          quoteDetailsData?.viewQuoteTW
                            ?.vehicleDetails?.registrationNumber
                            ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                0,
                                2,
                              )
                            : ''
                        }`,
                        part2: `${
                          quoteDetailsData?.viewQuoteTW
                            ?.vehicleDetails?.registrationNumber
                            ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                2,
                                4,
                              )
                            : ''
                        }`,
                        part3: `${
                          quoteDetailsData?.viewQuoteTW
                            ?.vehicleDetails?.registrationNumber
                            ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                4,
                                6,
                              )
                            : ''
                        }`,
                        part4: `${
                          quoteDetailsData?.viewQuoteTW
                            ?.vehicleDetails?.registrationNumber
                            ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                6,
                                10,
                              )
                            : ''
                        }`,
                      },
                      suggestedIDV:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.suggestedIDV !==
                        null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.suggestedIDV}`
                          : '',
                      minSuggestedIDV:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.minSuggestedIDV !==
                        null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.minSuggestedIDV}`
                          : '',
                      maxSuggestedIDV:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.maxSuggestedIDV !==
                        null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.maxSuggestedIDV}`
                          : '',
                      changedIDV:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.firstYearIDV !==
                        null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.firstYearIDV}`
                          : '',
                      adjustmentIRF:
                        quoteDetailsData?.viewQuoteTW?.irf1 !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.irf1}`
                          : '0',
                      irfPctMax:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.irfPctMax !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMax}`
                          : '',
                      idvPctMax:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.idvPctMax !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMax}`
                          : '',
                      idvPctMin:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.idvPctMin !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMin}`
                          : '',
                      irfPctMin:
                        quoteDetailsData?.viewQuoteTW
                          ?.insuredDeclaredValue?.irfPctMin !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMin}`
                          : '',
                      anyPreviousPolicyforVehicleTaken:
                        quoteDetailsData?.viewQuoteTW
                          ?.isPreviousPolicy
                          ? 'Yes'
                          : 'No',
                      isVehicleDetailsAvailable: quoteDetailsData
                        ?.viewQuoteTW?.vehicleDetails?.make?.code
                        ? true
                        : false,
                      policyCoverType: quoteDetailsData?.viewQuoteTW
                        ?.previousPolicy?.coverType
                        ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
                        : '',
                      policyTenure: quoteDetailsData?.viewQuoteTW
                        ?.previousPolicy?.policyTenure
                        ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
                        : '',
                      policyTenureValue:
                        PRD_PreviousPolicyTermList?.find(
                          (pT) =>
                            pT?.code?.toLowerCase() ===
                            quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure?.toLowerCase(),
                        )?.value,
                      policyStartDate: quoteDetailsData?.viewQuoteTW
                        ?.previousPolicy?.startDate
                        ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
                        : '',
                      policyExpiryDate: quoteDetailsData?.viewQuoteTW
                        ?.previousPolicy?.expiryDate
                        ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
                        : '',
                      totalClaimCount: quoteDetailsData?.viewQuoteTW
                        ?.previousClaims?.totalClaimCount
                        ? `${quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount}`
                        : '',
                      totalClaimCountValue:
                        PRD_TotalClaimCountList?.find(
                          (claimCount) =>
                            claimCount?.code?.toLowerCase() ===
                            quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                        )?.value,
                      noOfClaimsOneYear:
                        quoteDetailsData?.viewQuoteTW?.previousClaims
                          ?.claimsInYear1,
                      noOfClaimsTwoYears:
                        quoteDetailsData?.viewQuoteTW?.previousClaims
                          ?.claimsInYear2,
                      noOfClaimsThreeYears:
                        quoteDetailsData?.viewQuoteTW?.previousClaims
                          ?.claimsInYear3,
                      totalClaimAmount:
                        quoteDetailsData?.viewQuoteTW?.previousClaims
                          ?.totalClaimAmount,
                      previousYearNCBSlab:
                        quoteDetailsData?.viewQuoteTW?.previousClaims
                          ?.prevNCBSlab,
                      financerName:
                        quoteDetailsData?.viewQuoteTW?.financerName,
                      vehicleIsOwnedBy: `${
                        quoteDetailsData?.viewQuoteTW?.customer
                          ?.cust_type?.code
                          ? `${quoteDetailsData?.viewQuoteTW?.customer?.cust_type?.code}`
                          : ''
                      }${
                        quoteDetailsData?.viewQuoteTW?.customer
                          ?.indv_detail?.gender?.code
                          ? `#${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
                          : ''
                      }`,
                      vehicleOwnerTypeAndGender: {
                        gender: quoteDetailsData?.viewQuoteTW
                          ?.customer?.indv_detail?.gender?.code
                          ? `${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
                          : '',
                        organisationType:
                          quoteDetailsData?.viewQuoteTW?.customer
                            ?.cust_type?.code,
                      },
                      pincode: quoteDetailsData?.viewQuoteTW?.location
                        ?.pincode
                        ? `${quoteDetailsData?.viewQuoteTW?.location?.pincode}`
                        : '',
                      state: quoteDetailsData?.viewQuoteTW?.location
                        ?.state
                        ? `${quoteDetailsData?.viewQuoteTW?.location?.state}`
                        : '',
                      getAdditionalCreditScore: quoteDetailsData
                        ?.viewQuoteTW?.creditScoreDetials
                        ?.discountOpted
                        ? 'Yes'
                        : 'No',
                      idProofType: quoteDetailsData?.viewQuoteTW
                        ?.creditScoreDetials?.idProofType
                        ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofType}`
                        : '',
                      idProofNumber: quoteDetailsData?.viewQuoteTW
                        ?.creditScoreDetials?.idProofType
                        ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofNumber}`
                        : '',
                      voluntaryDeductibleAmount:
                        quoteDetailsData?.viewQuoteTW
                          ?.voluntaryDeductibleAmt !== null
                          ? `${quoteDetailsData?.viewQuoteTW?.voluntaryDeductibleAmt}`
                          : '',
                      make: {
                        code: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.make?.code
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.code}`
                          : '',
                        value: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.make?.value
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.value}`
                          : '',
                      },
                      model: {
                        code: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.model?.code
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.code}`
                          : '',
                        value: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.model?.value
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.value}`
                          : '',
                      },
                      variant: {
                        code: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.variant?.code
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.code}`
                          : '',
                        value: quoteDetailsData?.viewQuoteTW
                          ?.vehicleDetails?.variant?.value
                          ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.value}`
                          : '',
                      },
                      fuelType: quoteDetailsData?.viewQuoteTW
                        ?.vehicleDetails?.fuelType
                        ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.fuelType}`
                        : '',
                      seatingCapacity: quoteDetailsData?.viewQuoteTW
                        ?.vehicleDetails?.seatingCapacity
                        ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.seatingCapacity}`
                        : '',
                      cubeCapacity: quoteDetailsData?.viewQuoteTW
                        ?.vehicleDetails?.cubicCapacity
                        ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.cubicCapacity}`
                        : '',
                      yearOfManufacture: quoteDetailsData?.viewQuoteTW
                        ?.vehicleDetails?.manufactureYear
                        ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.manufactureYear}`
                        : '',
                      dateOfReg: quoteDetailsData?.viewQuoteTW
                        ?.vehicleDetails?.regPurchaseDate
                        ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.regPurchaseDate}`
                        : '',
                      rtoLocationCode:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.rto?.rtoLocCode ||
                        quoteDetailsData?.viewQuoteTW?.rtoDetails
                          ?.rtoLocCode,
                      rtoLocationDesc:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.rto?.rtoLocDesc ||
                        quoteDetailsData?.viewQuoteTW?.rtoDetails
                          ?.rtoLocDesc,
                      rtoAuthorityCode:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.rto?.rtoAuthCode ||
                        quoteDetailsData?.viewQuoteTW?.rtoDetails
                          ?.rtoAuthCode,
                      engineNo:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.engineNumber,
                      chasisNo:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.chasisNumber,
                      financerName:
                        quoteDetailsData?.viewQuoteTW?.vehicleDetails
                          ?.financerName ||
                        quoteDetailsData?.viewQuoteTW?.financerName,
                      prevInsurance: {
                        insurerName: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.insurerName
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.insurerName}`
                          : '',
                        policyNumber: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.policyNumber
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyNumber}`
                          : '',
                        expiryDate: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.expiryDate
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
                          : '',
                        startDate: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.startDate
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
                          : '',
                        coverType: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.coverType
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
                          : '',
                        policyTenure: quoteDetailsData?.viewQuoteTW
                          ?.previousPolicy?.policyTenure
                          ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
                          : '',
                      },
                    });
                    setCopyQuoteDisplay(false);
                    setMoveToPlans(true);
                    document.body.classList.remove(
                      'overflow-y-hidden',
                    );
                    window?.scrollTo({ top: 0, behavior: 'smooth' });
                  } catch (error) {
                    setCopying(false);
                    setCopyFromQuoteNumber('');
                    setAlerts([
                      {
                        id: Date.now() + Math.random(),
                        content: <Text>{error?.message}</Text>,
                        type: 'error',
                        disableClose: false,
                        timeout: 3000,
                      },
                    ]);
                  }
                }}
                size={'small'}
                className="flex items-center h-8 space-x-2 w-24"
                iconPre={
                  copying &&
                  copyFromQuoteNumber ===
                    row?.original?.quoteNumber ? (
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  ) : undefined
                }
                iconPost={
                  copying &&
                  copyFromQuoteNumber ===
                    row?.original?.quoteNumber ? undefined : (
                    <FontAwesomeIcon icon={faChevronRight} />
                  )
                }
                disabled={copying}
              >
                {copying &&
                copyFromQuoteNumber === row?.original?.quoteNumber
                  ? 'Importing...'
                  : 'Import'}
              </Button>
            </Text>
          );
        },
      },
    ].filter((d) => d.Header !== undefined),
    grid: {
      repeat: 1,
      gap: 2,
      gapX: 2,
      gapY: 2,
      gridClassName: 'w-full',
      gridItemsArr:
        searchData?.length > 0
          ? searchData?.map((quoteData) => {
              return {
                id: `${quoteData?.quoteNumber}`,
                content: (
                  <Paper
                    className={`border-2 rounded p-4 min-h-full 
                    ${'hover:bg-neutral-light'}
                    `}
                  >
                    <Text
                      className={
                        'flex flex-col w-full justify-between h-full'
                      }
                    >
                      <Text
                        className={
                          'flex items-center justify-between h-full w-full'
                        }
                      >
                        <Text
                          className={
                            'font-semibold flex space-x-2 items-start w-full'
                          }
                        >
                          <Text
                            className={
                              'flex flex-col justify-start items-center'
                            }
                          >
                            <Text
                              severity={'info'}
                              className="border-2 w-14 flex flex-col items-center justify-center h-12 rounded-lg bg-white mr-1.5"
                            >
                              <FontAwesomeIcon
                                icon={faMotorcycle}
                                size={'2x'}
                              />
                            </Text>
                          </Text>
                          <Text
                            className={
                              'flex flex-col h-full justify-between w-full'
                            }
                          >
                            <Text
                              severity={'info'}
                              className={
                                'font-semibold w-full flex space-x-2 justify-between'
                              }
                            >
                              <Text className={'font-semibold'}>
                                {quoteData?.quoteNumber},
                                {quoteData?.product?.productName}
                              </Text>
                              <Text className={'font-semibold'}>
                                {quoteData?.quoteStatus}
                              </Text>
                            </Text>
                            <Text
                              type={'label'}
                              className={
                                'w-full h-full mb-5 text-neutral-darker'
                              }
                            >
                              Saved on {quoteData?.quoteCreationDate}
                            </Text>
                            <Text className={'w-full h-full'}>
                              <Grid
                                repeat={4}
                                className={'w-full h-full'}
                              >
                                {quoteData?.customer?.indv_detail
                                  ?.full_name ||
                                quoteData?.customer?.org_detail
                                  ?.org_name ? (
                                  <GridItem
                                    colSpan={
                                      quoteData?.lob?.lobName
                                        ?.toString()
                                        ?.toLowerCase() === 'fire'
                                        ? 3
                                        : 1
                                    }
                                    className={
                                      'flex space-x-2 w-full justify-start break-all'
                                    }
                                  >
                                    <Text>
                                      <FontAwesomeIcon
                                        icon={faUser}
                                      />
                                    </Text>
                                    <Text>
                                      {quoteData?.customer
                                        ?.indv_detail?.full_name ||
                                        quoteData?.customer
                                          ?.org_detail?.org_name}
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {quoteData?.customer?.contact
                                  ?.mobile ? (
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full'
                                    }
                                  >
                                    <Text>
                                      <FontAwesomeIcon
                                        icon={faMobileAlt}
                                      />
                                    </Text>
                                    <Text>
                                      {
                                        quoteData?.customer?.contact
                                          ?.mobile
                                      }
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {quoteData?.customer?.contact
                                  ?.email ? (
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full'
                                    }
                                  >
                                    <Text>
                                      <FontAwesomeIcon
                                        icon={faEnvelope}
                                      />
                                    </Text>
                                    <Text>
                                      {
                                        quoteData?.customer?.contact
                                          ?.email
                                      }
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full justify-end'
                                    }
                                  >
                                    <Text className="flex justify-end">
                                      <Button
                                        type={'button'}
                                        flat={false}
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          try {
                                            const fetchQuoteDetails =
                                              fetchQuery({
                                                query: VIEW_QUOTE_TW,
                                                fetchPolicy:
                                                  'network-only',
                                                variables: {
                                                  input: {
                                                    quoteNumber:
                                                      quoteData?.quoteNumber,
                                                  },
                                                },
                                              });
                                            const getMotorQuoteVar =
                                              fetchQuery({
                                                query:
                                                  GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                                              });
                                            setAlerts([]);
                                            setCopyFromQuoteNumber(
                                              quoteData?.quoteNumber,
                                            );
                                            setCopying(true);
                                            const {
                                              data: quoteDetailsData,
                                            } = await fetchQuoteDetails;
                                            const {
                                              data: motorReactiveVarData,
                                            } = await getMotorQuoteVar;
                                            const metaQuery =
                                              fetchQuery({
                                                query: META_QUERIES,
                                                variables: {
                                                  productCode:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.product
                                                      ?.productCode,
                                                  productType:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.productType,
                                                },
                                              });
                                            const {
                                              data: metaQueryData,
                                            } = await metaQuery;
                                              const {
                                                lobProductList,
                                                getTwoWheelerBusinessType,
                                                PRD_TotalClaimCountList,
                                                PRD_PreviousPolicyTermList,
                                              } = metaQueryData;
                                            const { motorQuote } =
                                              motorReactiveVarData;
                                            setCopying(false);
                                            updateMotorQuote({
                                              currentTab: 'covers',
                                              captureMode: 'create',
                                              productType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.productType,
                                              productTypeValue:
                                                lobProductList
                                                  ?.find(
                                                (lpl) =>
                                                      lpl?.lob_code
                                                        ?.toString()
                                                        ?.toLowerCase() ===
                                                      lobCodeFromURL
                                                        ?.toString()
                                                        ?.toLowerCase(),
                                              )
                                              ?.products?.find(
                                                (prd) =>
                                                  prd?.product_code
                                                    ?.toString()
                                                    ?.toLowerCase() ===
                                                      productCodeFromURL
                                                        ?.toString()
                                                        ?.toLowerCase(),
                                              )
                                              ?.product_types?.find(
                                                (p) =>
                                                      p?.code?.toLowerCase() ===
                                                      quoteDetailsData?.viewQuoteTW?.productType?.toLowerCase(),
                                              )?.value,
                                              businessType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.businessType,
                                              businessTypeValue:
                                                getTwoWheelerBusinessType?.value,
                                              regNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.registrationNumber,
                                              quotationType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.quotationType,
                                                  isRegNoVerified: true,
          isPrevClaimsAvailable:
          getTwoWheelerBusinessType?.value?.toLowerCase() ===
            'roll over'
              ? true
              : false,
          isPrevInsuranceAvailable:
          getTwoWheelerBusinessType?.value?.toLowerCase() ===
            'roll over'
              ? true
              : false,
          mode: '',
          vehicleRegNo: {
            part1: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    0,
                    2,
                  )
                : ''
            }`,
            part2: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    2,
                    4,
                  )
                : ''
            }`,
            part3: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    4,
                    6,
                  )
                : ''
            }`,
            part4: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    6,
                    10,
                  )
                : ''
            }`,
          },
          suggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.suggestedIDV !==
            null
              ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.suggestedIDV}`
              : '',
          minSuggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.minSuggestedIDV !==
                                                null
              ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.minSuggestedIDV}`
              : '',
          maxSuggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.maxSuggestedIDV !==
                                                null
              ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.maxSuggestedIDV}`
              : '',
          changedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.firstYearIDV !==
            null
              ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.firstYearIDV}`
              : '',
          adjustmentIRF:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.irf1 !== null
              ? `${quoteDetailsData?.viewQuoteTW?.irf1}`
              : '0',
                                              irfPctMax:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.irfPctMax !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMax}`
                                                  : '',
                                              idvPctMax:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.idvPctMax !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMax}`
              : '',
                                              idvPctMin:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.idvPctMin !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMin}`
                                                  : '',
                                              irfPctMin:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.irfPctMin !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMin}`
              : '',
                                              anyPreviousPolicyforVehicleTaken:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
            ?.isPreviousPolicy
            ? 'Yes'
            : 'No',
                                              isVehicleDetailsAvailable:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
            ?.make?.code
            ? true
            : false,
                                              policyCoverType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
            ?.coverType
            ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
            : '',
                                              policyTenure:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
            ?.policyTenure
            ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
            : '',
                                              policyTenureValue:
                                                PRD_PreviousPolicyTermList?.find(
            (pT) =>
              pT?.code?.toLowerCase() ===
              quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure?.toLowerCase(),
          )?.value,
                                              policyStartDate:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
            ?.startDate
            ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
            : '',
                                              policyExpiryDate:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
            ?.expiryDate
            ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
            : '',
                                              totalClaimCount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
            ?.totalClaimCount
            ? `${quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount}`
            : '',
                                              totalClaimCountValue:
                                                PRD_TotalClaimCountList?.find(
            (claimCount) =>
              claimCount?.code?.toLowerCase() ===
              quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount?.toLowerCase(),
          )?.value,
          noOfClaimsOneYear:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear1,
          noOfClaimsTwoYears:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear2,
          noOfClaimsThreeYears:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear3,
          totalClaimAmount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.totalClaimAmount,
          previousYearNCBSlab:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.prevNCBSlab,
                                              financerName:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.financerName,
          vehicleIsOwnedBy: `${
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.customer
                                                  ?.cust_type?.code
              ? `${quoteDetailsData?.viewQuoteTW?.customer?.cust_type?.code}`
              : ''
          }${
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.customer
                                                  ?.indv_detail
                                                  ?.gender?.code
              ? `#${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
              : ''
          }`,
                                              vehicleOwnerTypeAndGender:
                                                {
                                                  gender:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.customer
                                                      ?.indv_detail
                                                      ?.gender?.code
              ? `${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
              : '',
            organisationType:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.customer
                                                      ?.cust_type
                                                      ?.code,
          },
                                              pincode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.location?.pincode
            ? `${quoteDetailsData?.viewQuoteTW?.location?.pincode}`
            : '',
                                              state: quoteDetailsData
                                                ?.viewQuoteTW
                                                ?.location?.state
            ? `${quoteDetailsData?.viewQuoteTW?.location?.state}`
            : '',
                                              getAdditionalCreditScore:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
                                                  ?.discountOpted
            ? 'Yes'
            : 'No',
                                              idProofType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
            ?.idProofType
            ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofType}`
            : '',
                                              idProofNumber:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
            ?.idProofType
            ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofNumber}`
            : '',
          voluntaryDeductibleAmount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.voluntaryDeductibleAmt !==
                                                null
              ? `${quoteDetailsData?.viewQuoteTW?.voluntaryDeductibleAmt}`
              : '',
          make: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.make?.code
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.code}`
              : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.make?.value
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.value}`
              : '',
          },
          model: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.model?.code
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.code}`
              : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.model?.value
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.value}`
              : '',
          },
          variant: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.variant?.code
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.code}`
              : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.variant?.value
              ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.value}`
              : '',
          },
                                              fuelType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.fuelType
            ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.fuelType}`
            : '',
                                              seatingCapacity:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
            ?.seatingCapacity
            ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.seatingCapacity}`
            : '',
                                              cubeCapacity:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
            ?.cubicCapacity
            ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.cubicCapacity}`
            : '',
                                              yearOfManufacture:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
            ?.manufactureYear
            ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.manufactureYear}`
            : '',
                                              dateOfReg:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
            ?.regPurchaseDate
            ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.regPurchaseDate}`
            : '',
          rtoLocationCode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto?.rtoLocCode ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoLocCode,
          rtoLocationDesc:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto?.rtoLocDesc ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoLocDesc,
          rtoAuthorityCode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto
                                                  ?.rtoAuthCode ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoAuthCode,
                                              engineNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.engineNumber,
                                              chasisNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.chasisNumber,
          financerName:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.financerName ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.financerName,
          prevInsurance: {
                                                insurerName:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
              ?.insurerName
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.insurerName}`
              : '',
                                                policyNumber:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
              ?.policyNumber
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyNumber}`
              : '',
                                                expiryDate:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.expiryDate
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
              : '',
                                                startDate:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.startDate
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
              : '',
                                                coverType:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.coverType
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
              : '',
                                                policyTenure:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
              ?.policyTenure
              ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
              : '',
          },
                                            });
                                            setCopyQuoteDisplay(
                                              false,
                                            );
                                            setMoveToPlans(true);
                                            document.body.classList.remove(
                                              'overflow-y-hidden',
                                            );
                                            window?.scrollTo({
                                              top: 0,
                                              behavior: 'smooth',
                                            });
                                          } catch (error) {
                                            setCopyFromQuoteNumber(
                                              '',
                                            );
                                            setCopying(false);
                                            setAlerts([
                                              {
                                                id:
                                                  Date.now() +
                                                  Math.random(),
                                                content: (
                                                  <Text>
                                                    {error?.message}
                                                  </Text>
                                                ),
                                                type: 'error',
                                                disableClose: false,
                                                timeout: 3000,
                                              },
                                            ]);
                                          }
                                        }}
                                        size={'small'}
                                        className="flex items-center h-8 space-x-2"
                                        iconPre={
                                          copying &&
                                          copyFromQuoteNumber ===
                                            quoteData?.quoteNumber ? (
                                            <FontAwesomeIcon
                                              icon={faSpinner}
                                              spin={true}
                                            />
                                          ) : undefined
                                        }
                                        iconPost={
                                          copying &&
                                          copyFromQuoteNumber ===
                                            quoteData?.quoteNumber ? undefined : (
                                            <FontAwesomeIcon
                                              icon={faChevronRight}
                                            />
                                          )
                                        }
                                        disabled={copying}
                                      >
                                        {copying &&
                                        copyFromQuoteNumber ===
                                          quoteData?.quoteNumber
                                          ? 'Importing...'
                                          : 'Import'}
                                      </Button>
                                    </Text>
                                  </GridItem>
                                }
                              </Grid>
                            </Text>
                          </Text>
                        </Text>
                      </Text>
                    </Text>
                  </Paper>
                ),
                colSpan: 1,
                // onClick: async () => {

                //   try {
                //     const fetchQuoteDetails = fetchQuery({
                //       query: VIEW_QUOTE_TW,
                //       variables: {
                //         input: {
                //           quoteNumber: quoteData?.quoteNumber
                //         }
                //       }
                //     });
                //     const { data: quoteDetailsData} = await fetchQuoteDetails;
                //     updateMotorQuote({
                //       currentTab: 'covers',
                //       captureMode: 'create',
                //       location: quoteDetailsData?.viewQuote?.location,
                //       quotationType: quoteDetailsData?.viewQuote?.quotationType,
                //     });
                //     setCopyQuoteDisplay(false);
                //     setMoveToPlans(true);
                //     document.body.classList.remove('overflow-y-hidden');
                //   }
                //   catch(error) {
                //   }
                // },
              };
            })
          : [],
    },
    card: {
      gap: 2,
      gapX: 2,
      gapY: 2,
      cardClassName: 'w-full',
      cardItemsArr:
        searchData?.length > 0
          ? searchData?.map((quoteData) => {
              return {
                id: `${quoteData?.quoteNumber}`,
                content: (
                  <Paper
                    className={`border-2 rounded p-4 min-h-full ${
                      //   cardSummaryDetail?.quoteNumber
                      //     .toString()
                      //     ?.toLowerCase() ===
                      //   quoteData?.quoteNumber
                      //     ?.toString()
                      //     ?.toLowerCase()
                      //     ? 'bg-neutral'
                      //     :
                      'hover:bg-neutral-light'
                    }`}
                  >
                    <Text
                      className={
                        'flex flex-col w-full justify-between h-full'
                      }
                    >
                      <Text
                        className={
                          'flex items-center justify-between h-full w-full'
                        }
                      >
                        <Text
                          className={
                            'font-semibold flex space-x-2 items-start w-full'
                          }
                        >
                          <Text
                            className={
                              'flex flex-col h-full justify-between w-full'
                            }
                          >
                            <Text
                              severity={'info'}
                              className={
                                'font-semibold w-full flex space-x-2 items-center justify-between'
                              }
                            >
                              <Text className={'font-semibold'}>
                                {quoteData?.quoteNumber},
                                {quoteData?.product?.productName}
                              </Text>
                              <Text className={'font-semibold'}>
                                {quoteData?.quoteStatus}
                              </Text>
                            </Text>
                            <Text
                              type={'label'}
                              className={
                                'w-full h-full mb-5 text-neutral-darker'
                              }
                            >
                              Saved on {quoteData?.quoteCreationDate}
                            </Text>
                            <Text className={'w-full h-full'}>
                              <Grid
                                repeat={2}
                                className={'w-full h-full'}
                              >
                                {quoteData?.customer?.indv_detail
                                  ?.full_name ||
                                quoteData?.customer?.org_detail
                                  ?.org_name ? (
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full justify-start'
                                    }
                                  >
                                    <Text type={'label'}>
                                      <FontAwesomeIcon
                                        icon={faUser}
                                      />
                                    </Text>
                                    <Text type={'label'}>
                                      {quoteData?.customer
                                        ?.indv_detail?.full_name ||
                                        quoteData?.customer
                                          ?.org_detail?.org_name}
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {quoteData?.customer?.contact
                                  ?.mobile ? (
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      screenType === 'mobile'
                                        ? 'flex space-x-2 w-full justify-end'
                                        : 'flex space-x-2 w-full justify-start'
                                    }
                                  >
                                    <Text type={'label'}>
                                      <FontAwesomeIcon
                                        icon={faMobileAlt}
                                      />
                                    </Text>
                                    <Text type={'label'}>
                                      {
                                        quoteData?.customer?.contact
                                          ?.mobile
                                      }
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {quoteData?.customer?.contact
                                  ?.email ? (
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full break-all'
                                    }
                                  >
                                    <Text type={'label'}>
                                      <FontAwesomeIcon
                                        icon={faEnvelope}
                                      />
                                    </Text>
                                    <Text
                                      type={'label'}
                                      className={'break-all'}
                                    >
                                      {
                                        quoteData?.customer?.contact
                                          ?.email
                                      }
                                    </Text>
                                  </GridItem>
                                ) : (
                                  ''
                                )}
                                {
                                  <GridItem
                                    colSpan={1}
                                    className={
                                      'flex space-x-2 w-full justify-end'
                                    }
                                  >
                                    <Text className="flex justify-end">
                                      <Button
                                        type={'button'}
                                        flat={false}
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          try {
                                            const fetchQuoteDetails =
                                              fetchQuery({
                                                query: VIEW_QUOTE_TW,
                                                variables: {
                                                  input: {
                                                    quoteNumber:
                                                      quoteData?.quoteNumber,
                                                  },
                                                },
                                              });
                                            const getMotorQuoteVar =
                                              fetchQuery({
                                                query:
                                                  GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                                              });
                                            setAlerts([]);
                                            setCopyFromQuoteNumber(
                                              quoteData?.quoteNumber,
                                            );
                                            setCopying(true);
                                            const {
                                              data: quoteDetailsData,
                                            } = await fetchQuoteDetails;
                                            const {
                                              data: motorReactiveVarData,
                                            } = await getMotorQuoteVar;
                                            const metaQuery =
                                              fetchQuery({
                                                query: META_QUERIES,
                                                variables: {
                                                  productCode:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.product
                                                      ?.productCode,
                                                  productType:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.productType,
                                                },
                                              });
                                            const {
                                              data: metaQueryData,
                                            } = await metaQuery;
                                            const {
                                              lobProductList,
                                              getTwoWheelerBusinessType,
                                              PRD_TotalClaimCountList,
                                              PRD_PreviousPolicyTermList,
                                            } = metaQueryData;
                                            const { motorQuote } =
                                              motorReactiveVarData;
                                            setCopying(false);
                                            updateMotorQuote({
                                              currentTab: 'covers',
                                              captureMode: 'create',
                                              productType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.productType,
                                              productTypeValue:
                                                lobProductList
                                                  ?.find(
                                                    (lpl) =>
                                                      lpl?.lob_code
                                                        ?.toString()
                                                        ?.toLowerCase() ===
                                                      lobCodeFromURL
                                                        ?.toString()
                                                        ?.toLowerCase(),
                                                  )
                                                  ?.products?.find(
                                                    (prd) =>
                                                      prd?.product_code
                                                        ?.toString()
                                                        ?.toLowerCase() ===
                                                      productCodeFromURL
                                                        ?.toString()
                                                        ?.toLowerCase(),
                                                  )
                                                  ?.product_types?.find(
                                                    (p) =>
                                                      p?.code?.toLowerCase() ===
                                                      quoteDetailsData?.viewQuoteTW?.productType?.toLowerCase(),
                                                  )?.value,
                                              businessType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.businessType,
                                              businessTypeValue:
                                                getTwoWheelerBusinessType?.value,
                                              regNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.registrationNumber,
                                              quotationType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.quotationType,
                                              isRegNoVerified: true,
                                              isPrevClaimsAvailable:
                                                getTwoWheelerBusinessType?.value?.toLowerCase() ===
                                                'roll over'
                                                  ? true
                                                  : false,
                                              isPrevInsuranceAvailable:
                                                getTwoWheelerBusinessType?.value?.toLowerCase() ===
                                                'roll over'
                                                  ? true
                                                  : false,
                                              mode: '',
                                              vehicleRegNo: {
                                                part1: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                                                    ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                                        0,
                                                        2,
                                                      )
                                                    : ''
                                                }`,
                                                part2: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                                                    ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                                        2,
                                                        4,
                                                      )
                                                    : ''
                                                }`,
                                                part3: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                                                    ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                                        4,
                                                        6,
                                                      )
                                                    : ''
                                                }`,
                                                part4: `${
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.registrationNumber
                                                    ? quoteDetailsData?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                                                        6,
                                                        10,
                                                      )
                                                    : ''
                                                }`,
                                              },
                                              suggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.suggestedIDV !==
                                                null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.suggestedIDV}`
                                                  : '',
                                              minSuggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.minSuggestedIDV !==
                                                null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.minSuggestedIDV}`
                                                  : '',
                                              maxSuggestedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.maxSuggestedIDV !==
                                                null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.maxSuggestedIDV}`
                                                  : '',
                                              changedIDV:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.firstYearIDV !==
                                                null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.firstYearIDV}`
                                                  : '',
                                              adjustmentIRF:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.irf1 !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.irf1}`
                                                  : '0',
                                              irfPctMax:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.irfPctMax !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMax}`
                                                  : '',
                                              idvPctMax:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.idvPctMax !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMax}`
                                                  : '',
                                              idvPctMin:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.idvPctMin !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.idvPctMin}`
                                                  : '',
                                              irfPctMin:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.insuredDeclaredValue
                                                  ?.irfPctMin !== null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.insuredDeclaredValue?.irfPctMin}`
                                                  : '',
                                              anyPreviousPolicyforVehicleTaken:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.isPreviousPolicy
                                                  ? 'Yes'
                                                  : 'No',
                                              isVehicleDetailsAvailable:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.make?.code
                                                  ? true
                                                  : false,
                                              policyCoverType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
                                                  ?.coverType
                                                  ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
                                                  : '',
                                              policyTenure:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
                                                  ?.policyTenure
                                                  ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
                                                  : '',
                                              policyTenureValue:
                                                PRD_PreviousPolicyTermList?.find(
                                                  (pT) =>
                                                    pT?.code?.toLowerCase() ===
                                                    quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure?.toLowerCase(),
                                                )?.value,
                                              policyStartDate:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
                                                  ?.startDate
                                                  ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
                                                  : '',
                                              policyExpiryDate:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousPolicy
                                                  ?.expiryDate
                                                  ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
                                                  : '',
                                              totalClaimCount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.totalClaimCount
                                                  ? `${quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount}`
                                                  : '',
                                              totalClaimCountValue:
                                                PRD_TotalClaimCountList?.find(
                                                  (claimCount) =>
                                                    claimCount?.code?.toLowerCase() ===
                                                    quoteDetailsData?.viewQuoteTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                                                )?.value,
                                              noOfClaimsOneYear:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear1,
                                              noOfClaimsTwoYears:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear2,
                                              noOfClaimsThreeYears:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.claimsInYear3,
                                              totalClaimAmount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.totalClaimAmount,
                                              previousYearNCBSlab:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.previousClaims
                                                  ?.prevNCBSlab,
                                              financerName:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.financerName,
                                              vehicleIsOwnedBy: `${
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.customer
                                                  ?.cust_type?.code
                                                  ? `${quoteDetailsData?.viewQuoteTW?.customer?.cust_type?.code}`
                                                  : ''
                                              }${
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.customer
                                                  ?.indv_detail
                                                  ?.gender?.code
                                                  ? `#${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
                                                  : ''
                                              }`,
                                              vehicleOwnerTypeAndGender:
                                                {
                                                  gender:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.customer
                                                      ?.indv_detail
                                                      ?.gender?.code
                                                      ? `${quoteDetailsData?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
                                                      : '',
                                                  organisationType:
                                                    quoteDetailsData
                                                      ?.viewQuoteTW
                                                      ?.customer
                                                      ?.cust_type
                                                      ?.code,
                                                },
                                              pincode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.location?.pincode
                                                  ? `${quoteDetailsData?.viewQuoteTW?.location?.pincode}`
                                                  : '',
                                              state: quoteDetailsData
                                                ?.viewQuoteTW
                                                ?.location?.state
                                                ? `${quoteDetailsData?.viewQuoteTW?.location?.state}`
                                                : '',
                                              getAdditionalCreditScore:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
                                                  ?.discountOpted
                                                  ? 'Yes'
                                                  : 'No',
                                              idProofType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
                                                  ?.idProofType
                                                  ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofType}`
                                                  : '',
                                              idProofNumber:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.creditScoreDetials
                                                  ?.idProofType
                                                  ? `${quoteDetailsData?.viewQuoteTW?.creditScoreDetials?.idProofNumber}`
                                                  : '',
                                              voluntaryDeductibleAmount:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.voluntaryDeductibleAmt !==
                                                null
                                                  ? `${quoteDetailsData?.viewQuoteTW?.voluntaryDeductibleAmt}`
                                                  : '',
                                              make: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.make?.code
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.code}`
                                                  : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.make?.value
                                                    ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.make?.value}`
                                                    : '',
                                              },
                                              model: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.model?.code
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.code}`
                                                  : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.model?.value
                                                    ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.model?.value}`
                                                    : '',
                                              },
                                              variant: {
                                                code: quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.variant?.code
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.code}`
                                                  : '',
                                                value:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.vehicleDetails
                                                    ?.variant?.value
                                                    ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.variant?.value}`
                                                    : '',
                                              },
                                              fuelType:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.fuelType
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.fuelType}`
                                                  : '',
                                              seatingCapacity:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.seatingCapacity
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.seatingCapacity}`
                                                  : '',
                                              cubeCapacity:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.cubicCapacity
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.cubicCapacity}`
                                                  : '',
                                              yearOfManufacture:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.manufactureYear
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.manufactureYear}`
                                                  : '',
                                              dateOfReg:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.regPurchaseDate
                                                  ? `${quoteDetailsData?.viewQuoteTW?.vehicleDetails?.regPurchaseDate}`
                                                  : '',
                                              rtoLocationCode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto?.rtoLocCode ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoLocCode,
                                              rtoLocationDesc:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto?.rtoLocDesc ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoLocDesc,
                                              rtoAuthorityCode:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.rto
                                                  ?.rtoAuthCode ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.rtoDetails
                                                  ?.rtoAuthCode,
                                              engineNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.engineNumber,
                                              chasisNo:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.chasisNumber,
                                              financerName:
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.vehicleDetails
                                                  ?.financerName ||
                                                quoteDetailsData
                                                  ?.viewQuoteTW
                                                  ?.financerName,
                                              prevInsurance: {
                                                insurerName:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.insurerName
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.insurerName}`
                                                    : '',
                                                policyNumber:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.policyNumber
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyNumber}`
                                                    : '',
                                                expiryDate:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.expiryDate
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.expiryDate}`
                                                    : '',
                                                startDate:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.startDate
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.startDate}`
                                                    : '',
                                                coverType:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.coverType
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.coverType}`
                                                    : '',
                                                policyTenure:
                                                  quoteDetailsData
                                                    ?.viewQuoteTW
                                                    ?.previousPolicy
                                                    ?.policyTenure
                                                    ? `${quoteDetailsData?.viewQuoteTW?.previousPolicy?.policyTenure}`
                                                    : '',
                                              },
                                            });
                                            setCopyQuoteDisplay(
                                              false,
                                            );
                                            setMoveToPlans(true);
                                            document.body.classList.remove(
                                              'overflow-y-hidden',
                                            );
                                            window?.scrollTo({
                                              top: 0,
                                              behavior: 'smooth',
                                            });
                                          } catch (error) {
                                            setCopying(false);
                                            setCopyFromQuoteNumber(
                                              '',
                                            );
                                            setAlerts([
                                              {
                                                id:
                                                  Date.now() +
                                                  Math.random(),
                                                content: (
                                                  <Text>
                                                    {error?.message}
                                                  </Text>
                                                ),
                                                type: 'error',
                                                disableClose: false,
                                                timeout: 3000,
                                              },
                                            ]);
                                          }
                                        }}
                                        size={'small'}
                                        className="flex items-center h-8 space-x-2"
                                        iconPre={
                                          copying &&
                                          copyFromQuoteNumber ===
                                            quoteData?.quoteNumber ? (
                                            <FontAwesomeIcon
                                              icon={faSpinner}
                                              spin={true}
                                            />
                                          ) : undefined
                                        }
                                        iconPost={
                                          copying &&
                                          copyFromQuoteNumber ===
                                            quoteData?.quoteNumber ? undefined : (
                                            <FontAwesomeIcon
                                              icon={faChevronRight}
                                            />
                                          )
                                        }
                                        disabled={copying}
                                      >
                                        {copying &&
                                        copyFromQuoteNumber ===
                                          quoteData?.quoteNumber
                                          ? 'Importing...'
                                          : 'Import'}
                                      </Button>
                                    </Text>
                                  </GridItem>
                                }
                              </Grid>
                            </Text>
                          </Text>
                        </Text>
                      </Text>
                    </Text>
                  </Paper>
                ),
                colSpan: 1,
              };
            })
          : [],
    },
    isSortRequired: false,
    list: searchData.map((viewQuote) => {
      return {
        id: `${viewQuote.quoteNumber}`,
        title: `${viewQuote.quoteNumber}`,
        subtitle: (
          <div className="flex flex-col">
            <span>
              {viewQuote?.customer?.org_detail?.org_name
                ? viewQuote?.customer?.org_detail?.org_name
                : viewQuote?.customer?.indv_detail?.full_name
                ? viewQuote?.customer?.indv_detail?.full_name
                : [
                    viewQuote?.customer?.indv_detail?.first_name?.trim(),
                    viewQuote?.customer?.indv_detail?.middle_name?.trim(),
                    viewQuote?.customer?.indv_detail?.surname?.trim(),
                  ].join(' ')}
            </span>
            <span>
              {viewQuote?.quoteStatus}
              {' , '}
              {viewQuote?.quotationType}
            </span>
          </div>
        ),
        onClick: () => undefined,
        //   history.push(
        //     `/quote/saved/${viewQuote?.lob?.lobCode}/${viewQuote?.lob?.lobName}/${viewQuote?.product?.productCode}/${viewQuote?.product?.productName}/${viewQuote?.quoteNumber}`,
        //   ),
      };
    }),
  };

  const paginationInput = {
    offset,
    PAGE_SIZE,
    // onClickPrev: () => setCardSummaryDetail(undefined),
    // onClickNext: () => setCardSummaryDetail(undefined),
  };

  const onMessage = () => {
    return (
      <>
        {searchQuoteMeta?.resultCount > searchQuoteMeta?.maxRow && (
          <Text severity="warning" className="space-x-1">
            <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />
            <span>
              Search results are truncated to first{' '}
              {searchQuoteMeta?.maxRow} records.{'\t'}Please refine
              your search to get more accurate quote data.
            </span>
          </Text>
        )}
      </>
    );
  };

  return (
    // <Card className="lg:h-full min-h-screen">
    <>
      {/* <SearchResults */}
      <SearchResultsAdvanced
        {...{
          searchInput,
          searchResults,
          paginationInput,
          onMessage,
          switchViewEnabled: true,
          firstRowClickRequired: false,
        }}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
    // </Card>
  );
  // return (<></>)
}
